import React from "react";
import BaseButton from "../../../../components/BaseButton";
import BaseIcon from "../../../../components/BaseIcon";
import FullWidthPageBackground from "../../../../components/FullWidthPageBackground";
import { t } from "../../../../locales";
import "./style.scss";

export default function BlockWhyCoaching() {
  return (
    <div className="block-why-coaching">
      <FullWidthPageBackground className="block-why-coaching__background" />
      <div className="block-why-coaching__content">
        <h2 className="block-why-coaching__title h2">{t("Coaching for aspiring finance students")}</h2>
        <p className="block-why-coaching__description subtitle-1 fw-semibold">
          {t(
            "With coaches who’ve lived the industry and a proven, outcome-led approach, we equip students with the confidence and clarity to secure the job offers they deserve, while giving universities the employability results they need."
          )}
        </p>
        <BaseButton className="block-why-coaching__btn body-1 fw-bold pl-4 pr-3" to={"/coaches"} large dark>
          {t("Find a Coach")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
    </div>
  );
}
